import { moduleNames } from "data/enums/modules";
import { enumPermissionModules as EPM, enumPermissions as EP } from "../enums/authorization";

const en = {
  MenuSegment: {
    admin: 'Admin',
    affiliate: 'Affiliate',
    advertiser: 'Advertiser',
    user: 'User',
    system: 'System',
    dev: 'Dev'
  },
  MenuLink: {
    [moduleNames.ADMIN_HOME]: 'Home',
    [moduleNames.ADMIN_DASHBOARD]: 'Dashboard',
    [moduleNames.ADMIN_STATS_REPORT]: 'Report',
    [moduleNames.ADMIN_USERS_DROPDOWN]: 'Users',
    [moduleNames.ADMIN_USERS_LIST]: 'All users',
    [moduleNames.ADMIN_UNAPPROVED_USERS]: 'Unapproved',
    [moduleNames.ADMIN_USERS_BALANCE]: 'Balance',
    [moduleNames.ADMIN_CAMPAIGNS]: 'Campaigns',
    [moduleNames.ADMIN_UNAPPROVED_CREATIVES]: 'Unapproved creatives',
    [moduleNames.ADMIN_LOGS_DROPDOWN]: 'Logs',
    [moduleNames.ADMIN_TOPUPS]: 'Topups',
    [moduleNames.ADMIN_BIDS]: 'Bids',
    [moduleNames.ADMIN_OVERVIEW_DROPDOWN]: 'Overview',
    [moduleNames.ADMIN_OVERVIEW_COUNTRIES]: 'Countries',
    [moduleNames.ADMIN_GROUPS]: 'Groups',
    [moduleNames.ADMIN_RECOMMENDED_CPC]: 'Recommended CPC',
    [moduleNames.ADMIN_LOGIN_HISTORY]: 'Login history',
    [moduleNames.ADMIN_CAMPAIGNS_BIDS]: 'Campaign bids',
    [moduleNames.ADMIN_CAMPAIGNS_GROUPS]: 'Campaign groups',
    [moduleNames.ADMIN_PROFILE]: 'Profile',
    [moduleNames.ADMIN_CHANGELOG]: 'Change log',

    [`${moduleNames.DEV_BUILDER_DROPDOWN}_admin`]: 'Builder',
    [`${moduleNames.DEV_BUILDER_MODULE}_admin`]: 'Module',

    [moduleNames.ADVERTISER_HOME]: 'Home',
    [moduleNames.ADVERTISER_CAMPAIGNS]: 'Campaigns',
    [moduleNames.ADVERTISER_TOPUPS]: 'Topups',
    [moduleNames.ADVERTISER_LOGIN_HISTORY]: 'Login history',
    [moduleNames.ADVERTISER_REPORT]: 'Report',

    [moduleNames.ADVERTISER_DASHBOARD]: 'Dashboard',
    [moduleNames.ADVERTISER_OPTIMIZERS]: 'Optimizers',
    [moduleNames.ADMIN_LOGS_QUEUE_EMAIL]: 'Queue email',
    [moduleNames.ADVERTISER_STATS_REPORT]: 'Report',
    [moduleNames.ADVERTISER_PROFILE]: 'Profile',
    [moduleNames.ADVERTISER_TRACKING]: 'Tracking',
    [moduleNames.ADVERTISER_CREATIVES]: 'Creatives',

    [moduleNames.PAYMENT_INFORMATION]: 'Payment information',


  },
  PermissionsModalBody: {
    admin: 'Admin',
    [EPM.ADMIN_USERS]: 'Users',
    [EP.ADMIN_USERS_LIST]: 'List',
    [EP.ADMIN_USERS_GET]: 'Get',
    [EP.ADMIN_USERS_CREATE]: 'Create',
    [EP.ADMIN_USERS_UPDATE]: 'Update',
    [EP.ADMIN_USERS_DELETE]: 'Delete',
    [EP.ADMIN_USERS_VALIDATE]: 'Validate',

    [EPM.ADMIN_USERS_BALANCE]: 'Users - Balance',
    [EP.ADMIN_USERS_BALANCE_LIST]: 'List',

    [EPM.ADMIN_LOGS]: 'Logs',
    [EP.ADMIN_LOGS_QUEUE_EMAIL]: 'Queue emails',

    [EPM.ADMIN_OVERVIEW]: 'Overview',
    [EP.ADMIN_OVERVIEW_COUNTRIES]: 'Countries',

    [EPM.ADMIN_UNAPPROVED_USERS]: 'Unapproved Users',
    [EP.ADMIN_UNAPPROVED_USERS_LIST]: 'List',
    [EP.ADMIN_UNAPPROVED_USERS_APPROVED]: 'Approved',
    [EP.ADMIN_UNAPPROVED_USERS_REJECT]: 'Reject',
    [EP.ADMIN_UNAPPROVED_USERS_TOTAL]: 'Total',
    [EP.ADMIN_UNAPPROVED_USERS_SET_MANAGER]: 'Set manager',

    [EPM.ADMIN_COUNTRY]: 'Country',
    [EP.ADMIN_COUNTRY_LIST]: 'List',

    [EPM.ADMIN_PERMISSIONS]: 'Permission',
    [EP.ADMIN_PERMISSIONS_GET]: 'Get',
    [EP.ADMIN_PERMISSIONS_UPDATE]: 'Update',

    [EPM.ADMIN_CAMPAIGNS]: 'Campaigns',
    [EP.ADMIN_CAMPAIGNS_LIST]: 'List',
    [EP.ADMIN_CAMPAIGNS_GET]: 'Get',
    [EP.ADMIN_CAMPAIGNS_CREATE]: 'Create',
    [EP.ADMIN_CAMPAIGNS_UPDATE]: 'Update',
    [EP.ADMIN_CAMPAIGNS_DELETE]: 'Delete',
    [EP.ADMIN_CAMPAIGNS_ARCHIVE]: 'Archive',
    [EP.ADMIN_CAMPAIGNS_COPY]: 'Duplicate',

    [EPM.ADMIN_TOPUPS]: 'Top Ups',
    [EP.ADMIN_TOPUPS_LIST]: 'List',
    [EP.ADMIN_TOPUPS_GET]: 'Get',
    [EP.ADMIN_TOPUPS_CREATE]: 'Create',
    [EP.ADMIN_TOPUPS_UPDATE]: 'Update',
    [EP.ADMIN_TOPUPS_DELETE]: 'Delete',

    [EPM.ADMIN_UNAPPROVED_CREATIVES]: 'Unapproved Creatives',
    [EP.ADMIN_UNAPPROVED_CREATIVES_LIST]: 'List',
    [EP.ADMIN_UNAPPROVED_CREATIVES_APPROVED]: 'Approved',
    [EP.ADMIN_UNAPPROVED_CREATIVES_REJECT]: 'Reject',
    [EP.ADMIN_UNAPPROVED_CREATIVES_TOTAL]: 'Total',

    [EPM.ADMIN_FAST_LOGIN]: 'Fast login',
    [EP.ADMIN_FAST_LOGIN_CREATE]: 'Create',
    [EP.ADMIN_FAST_LOGIN_CHECK]: 'Check',

    [EPM.ADMIN_DASHBOARD]: 'Dashboard',
    [EP.ADMIN_DASHBOARD_SUM]: 'Sum',
    [EP.ADMIN_DASHBOARD_CHART]: 'Chart',

    [EPM.ADMIN_GROUPS]: 'Groups',
    [EP.ADMIN_GROUPS_LIST]: 'List',
    [EP.ADMIN_GROUPS_CREATE]: 'Create',
    [EP.ADMIN_GROUPS_DELETE]: 'Delete',
    [EP.ADMIN_GROUPS_UPDATE]: 'Update',
    [EP.ADMIN_GROUPS_GET]: 'Get',

    [EPM.ADMIN_BIDS]: 'Bids',
    [EP.ADMIN_BIDS_CREATE]: 'Create',
    [EP.ADMIN_BIDS_GET]: 'Get',
    [EP.ADMIN_BIDS_DELETE]: 'Delete',
    [EP.ADMIN_BIDS_LIST]: 'List',
    [EP.ADMIN_BIDS_UPDATE]: 'Update',

    [EPM.ADMIN_CAMPAIGNS_CREATIVES]: 'Campaign - Creatives',
    [EP.ADMIN_CAMPAIGNS_CREATIVES_CREATE]: 'Create',
    [EP.ADMIN_CAMPAIGNS_CREATIVES_GET]: 'Get',
    [EP.ADMIN_CAMPAIGNS_CREATIVES_DELETE]: 'Delete',
    [EP.ADMIN_CAMPAIGNS_CREATIVES_LIST]: 'List',
    [EP.ADMIN_CAMPAIGNS_CREATIVES_UPDATE]: 'Update',
    [EP.ADMIN_CAMPAIGNS_CREATIVES_DUPLICATE]: 'Duplicate',

    [EPM.ADMIN_RECOMMENDED_CPC]: 'Admin - Recommended CPC',
    [EP.ADMIN_RECOMMENDED_CPC_CREATE]: 'Create',
    [EP.ADMIN_RECOMMENDED_CPC_GET]: 'Get',
    [EP.ADMIN_RECOMMENDED_CPC_DELETE]: 'Delete',
    [EP.ADMIN_RECOMMENDED_CPC_LIST]: 'List',
    [EP.ADMIN_RECOMMENDED_CPC_UPDATE]: 'Update',


    [EPM.ADMIN_CAMPAIGNS_LIMITS]: 'Campaign - Limits',
    [EP.ADMIN_CAMPAIGNS_LIMITS_CREATE]: 'Create',
    [EP.ADMIN_CAMPAIGNS_LIMITS_LIST]: 'List',
    [EP.ADMIN_CAMPAIGNS_LIMITS_DELETE]: 'Delete',

    //Admin - Change Log
    [EPM.ADMIN_CHANGELOG]: "Change log",
    [EP.ADMIN_CHANGELOG_LIST]: "List",
    [EP.ADMIN_CHANGELOG_UPDATE]: "Update",
    [EP.ADMIN_CHANGELOG_CREATE]: "Create",
    [EP.ADMIN_CHANGELOG_DELETE]: "Delete",

    [EPM.ADMIN_CAMPAIGNS_AUDIENCE]: 'Campaign - Audience',
    [EP.ADMIN_CAMPAIGNS_AUDIENCE_GET]: 'Get',
    [EP.ADMIN_CAMPAIGNS_AUDIENCE_UPDATE]: 'Update',

    [EPM.ADMIN_CAMPAIGNS_PRICING]: 'Campaign - Pricing',
    [EP.ADMIN_CAMPAIGNS_PRICING_UPDATE]: 'Update',
    [EP.ADMIN_CAMPAIGNS_PRICING_GET]: 'Get',
    [EP.ADMIN_CAMPAIGNS_PRICING_DELETE]: 'Delete',

    [EPM.ADMIN_CAMPAIGNS_GROUPS]: 'Campaign - Groups',
    [EP.ADMIN_CAMPAIGNS_GROUPS_LIST]: 'List',
    [EP.ADMIN_CAMPAIGNS_GROUPS_UPDATE]: 'Update',

    [EPM.ADMIN_CAMPAIGNS_BIDS]: 'Campaign - Bids',
    [EP.ADMIN_CAMPAIGNS_BIDS_LIST]: 'List',
    [EP.ADMIN_CAMPAIGNS_BIDS_UPDATE]: 'Update',

    [EPM.ADMIN_STATS]: 'Stats',
    [EP.ADMIN_STATS_REPORT]: 'Report',
    [EP.ADMIN_STATS_BALANCE]: 'Balance',

    [EPM.ADMIN_LOGIN_HISTORY]: 'Login History',
    [EP.ADMIN_LOGIN_HISTORY_LIST]: 'List',

    [EPM.ADMIN_PROFILE]: 'Profile',
    [EP.ADMIN_PROFILE_GET]: 'Get',
    [EP.ADMIN_PROFILE_UPDATE]: 'Update',



    common: 'Common',
    [EPM.SETTINGS]: 'Settings',
    [EP.SETTINGS_GET]: 'Get',
    [EP.SETTINGS_UPDATE]: 'Update',

  },
  DashboardFooter: {
    companyName: 'MONETIZEAD',
    craftedLeft: 'Crafted with',
    craftedRight: 'by MonetizeAd'
  },
  Logout: {
    title: 'Logout',
    loading: 'Waiting to safely log out',
    completed: 'You have been safely logged out',
    button: 'Back to Login'
  },
  RequestErrors: {
    default: 'Unknown error',
    browser: {
      ERR_NETWORK: 'Network error'
    },
    network: {
      401: 'Unauthenticated user',
      403: 'Insufficient permissions',
      405: 'Method not allowed',
      406: 'Request not acceptable'
    },
    internal: {
      1: 'The requested method is not allowed',
      2: 'Login information on the system has not been forwarded',
      3: 'Username is invalid format',
      4: 'Password is invalid format',
      5: 'Login data is invalid',
      6: 'Database error',
      7: 'The POST request is incorrect format',
      8: 'The field is incorrect format',
      9: 'The entry already exists in the database',
      10: 'ID has to be passed through the GET method',
      11: 'The requested ID was not found in the database',
      12: 'One of the search parameters needs to be passed. [id]',
      13: 'The GET parameter is invalid format',
      14: 'The requested user was not found in the database',
      15: 'The requested country was not found in the database',
      16: "User doesn't have permission for the requested module / action",
      17: 'The mysql table name needs to be passed',
      18: 'Value not found in selected database.',
      19: 'Error passing key / value parameters',
      20: "The file format isn't allowed",
      21: 'The category was not found in the table',
      22: 'The product was not found in the table',
      23: 'The product ID was not passed',
      24: 'The variation was not found in the table',
      25: 'The selected table is not allowed to be viewed using this method',
      26: 'Unable to find user. General error',
      27: 'The requested number was not found, or is used in one of the campaigns',
      28: 'There are no users for payout for the requested period',
      29: 'Only pending payout is allowed to be deleted',
      30: 'It is necessary to pass the parameter: status',
      31: 'Unable to switch from existing to requested status',
      32: 'The contact has been taken or is already owned by the user',
      33: 'The entry has already been received in the system',
      34: 'It is necessary to pass the status through the GET method',
      35: 'The ticket does not exist or is closed for further response',
      36: 'The user does not have an active selected payment method',
      37: 'The amount you entered is not sufficient for the selected method',
      38: 'The selected method is currently unavailable for use',
      39: 'The selected method is currently inactive on your account',
      40: 'You currently have insufficient funds in your account',
      41: 'It is necessary to pass the username through the query parameter',
      42: 'Unable to find user in the database',
      43: 'A link to reset the password has already been requested for the user. Check your spam / junk',
      44: 'Token cannot be found',
      45: 'You need to re-enter the password correctly',
      46: 'Error in communication with an external service',
      47: 'Campaign spent the total budget limit. In order to active the campaign, please increase the total budget',
      48: 'Please enter the reason for rejecting the campaign, field: reject_comment',
      49: 'Please enter the reason for rejecting the creative, field: reject_comment',
      50: 'Input length exceeds the allowed limit',
      51: 'Minimal amount for payment.',
      52: 'The user needs to be approved by an admin so he could start creating advertisements',
      53: 'To create an advertisement, you need to have a minimal amount of $1 on your balance',
      54: 'Maximum number of campaigns created',
      55: 'Maximum amount for payment',
      56: 'If you want to create a campaign, please increase or turn off one of the limits',
      57: 'Campaign is not editable',
      58: 'country || subid are required parameters for this action',
      59: 'You need to increase your budget in order to activate this campaign',
      60: 'User id needs to be sent',
      61: 'User needs to have a manager assigned in order to be approved',
      62: 'Account already confirmed',
      63: "You're not assigned as a manager for this user",
      64: 'Max CPC needs to be higher than Min CPC',
      65: "You need to wait until the system accepts the campaign, you can then change the campaign's status",
      66: 'Allowed range is from 0 to 100',
      67: "Campaign not found or the campaign is in a status that is not archivable",
      68: "Maximum amount of creatives reached",
      69: "Maximum amount of creatives to generate with AI is 5",
      70: "Error while communicating with OpenAI, please try again in a few minues",
      71: "You have reached maximum amount of communications with AI today",
      72: "Invalid code",
    },
    custom: {}
  },
  [moduleNames.ADMIN_DASHBOARD]: {
    browserTabTitle: 'MonadPlug - Admin | Dashboard'
  },
  [moduleNames.ADMIN_REPORT_BALANCE]: {
    browserTabTitle: 'MonadLead - Balance report'
  },
  [moduleNames.ADMIN_STATS_REPORT]: {
    browserTabTitle: 'MonadPlug - Admin | Report'
  },
  [moduleNames.ADMIN_REPORT_OFFERS]: {
    browserTabTitle: 'MonadLead - Offers report'
  },
  [moduleNames.ADMIN_OVERVIEW_COUNTRIES]: {
    browserTabTitle: 'MonadPlug - Admin | Overview countries'
  },
  [moduleNames.ADMIN_REPORT_USERS]: {
    browserTabTitle: 'MonadLead - Users report'
  },
  [moduleNames.ADMIN_REPORT_DYNAMICS]: {
    browserTabTitle: 'MonadLead - Dynamic report'
  },
  [moduleNames.ADMIN_RECOMMENDED_CPC]: {
    browserTabTitle: 'MonadPlug - Admin | Recommended CPC',
    createLabel: 'Add CPC',
    editLabel: 'Edit',
    deleteLabel: 'Delete',
    editBulkLabel: 'Edit',
    createModalTitle: 'Create CPC',
    editModalTitle: 'Edit CPC',
    editModalBulkTitle: 'Edit CPCs',
    deleteBulkLabel: 'Delete',
    deleteModalTitle: 'Delete CPC',
    deleteModalBulkTitle: 'Delete CPCs'
  },
  [moduleNames.ADMIN_GROUPS]: {
    browserTabTitle: 'MonadPlug - Admin | Groups',
    createLabel: 'Add Group',
    editLabel: 'Edit',
    deleteLabel: 'Delete',
    editBulkLabel: 'Edit',
    createModalTitle: 'Create Group',
    editModalTitle: 'Edit Group',
    editModalBulkTitle: 'Edit Groups',
    deleteBulkLabel: 'Delete',
    deleteModalTitle: 'Delete Group',
    deleteModalBulkTitle: 'Delete Groups'
  },
  [moduleNames.ADMIN_CHANGELOG]: {
    browserTabTitle: 'MonadPlug - Change log',
    createLabel: 'Add log',
    editLabel: 'Edit',
    deleteLabel: 'Delete',
    editBulkLabel: 'Edit',
    addModalTitle: 'Create',
    editModalTitle: 'Edit log',
    editModalBulkTitle: 'Edit logs',
    deleteBulkLabel: 'Delete',
    deleteModalTitle: 'Delete log',
    deleteModalBulkTitle: 'Delete logs'
  },
  [moduleNames.ADMIN_OFFERS_PAYOUT_OFFERS]: {
    moduleTitle: 'Payouts',
    createLabel: 'Add payout',
    editLabel: 'Edit',
    editBulkLabel: 'Edit',
    addModalTitle: 'Create payout',
    editModalTitle: 'Edit payout',
    editModalBulkTitle: 'Edit payouts',
    deleteLabel: 'Delete',
    deleteBulkLabel: 'Delete',
    deleteModalTitle: 'Delete payout',
    deleteModalBulkTitle: 'Delete payouts',
  },
  [moduleNames.ADMIN_UNAPPROVED_CREATIVES]: {
    browserTabTitle: 'MonadPlug - Admin | Unapproved creatives'
  },
  [moduleNames.ADMIN_OFFERS_PAYOUT_USERS]: {
    moduleTitle: 'Payouts',
    createLabel: 'Add payout',
    editLabel: 'Edit',
    editBulkLabel: 'Edit',
    addModalTitle: 'Create payout',
    editModalTitle: 'Edit payout',
    editModalBulkTitle: 'Edit payouts',
    deleteLabel: 'Delete',
    deleteBulkLabel: 'Delete',
    deleteModalTitle: 'Delete payout',
    deleteModalBulkTitle: 'Delete payouts',
  },
  [moduleNames.ADMIN_OFFERS_ACCESS]: {
    browserTabTitle: 'MonadLead - Users access',
    createLabel: 'Add access',
    approveLabel: 'Approve',
    rejectLabel: 'Reject',
    rejectBulkLabel: 'Reject',
    addModalTitle: 'Create access',
    rejectModalTitle: 'Reject access',
    rejectModalBulkTitle: 'Reject accesses',
    approveModalTitle: 'Approve access',
    approveModalBody: 'Are you sure you want to approve access?',
  },
  [moduleNames.ADMIN_BALANCE]: {
    browserTabTitle: 'MonadLead - Balance',
    editLabel: 'Edit',
    editBulkLabel: 'Edit',
    editModalTitle: 'Edit balance',
    editModalBulkTitle: 'Edit balances',
    deleteLabel: 'Delete',
    deleteBulkLabel: 'Delete',
    deleteModalTitle: 'Delete balance',
    deleteModalBulkTitle: 'Delete balances',
  },

  [moduleNames.ADMIN_LOGIN_HISTORY]: {
    browserTabTitle: 'MonadPlug - Admin | Login history',
  },
  [moduleNames.ADMIN_USERS_BALANCE]: {
    browserTabTitle: 'MonadPlug - Admin | Users balance',
  },
  [moduleNames.ADMIN_LOGS_QUEUE_EMAIL]: {
    browserTabTitle: 'MonadPlug - Admin | Email queue',
  },

  [moduleNames.ADMIN_TOPUPS]: {
    browserTabTitle: 'MonadPlug - Admin | Topups',
    createLabel: 'Add topup',
    editLabel: 'Edit',
    editBulkLabel: 'Edit',
    createModalTitle: 'Create topup',
    editModalTitle: 'Edit topup',
    editModalBulkTitle: 'Edit topups',
    deleteLabel: 'Delete',
    deleteBulkLabel: 'Delete',
    deleteModalTitle: 'Delete topup',
    deleteModalBulkTitle: 'Delete topups',
  },
  [moduleNames.ADMIN_USERS_LIST]: {
    browserTabTitle: 'MonadPlug - Admin | Users',
    createLabel: 'Add user',
    editLabel: 'Edit',
    paymentLabel: 'Payment',
    authLabel: 'Auth',
    permissionsLabel: 'Permissions',
    deleteLabel: 'Delete',
    editBulkLabel: 'Edit',
    deleteBulkLabel: 'Delete',
    createModalTitle: 'Create user',
    editModalTitle: 'Edit user',
    authModalTitle: 'Edit user password',
    permissionModalTitle: 'User permissions',
    deleteModalTitle: 'Delete user',
    deleteModalBulkTitle: 'Delete users',
    editModalBulkTitle: 'Edit users',
  },
  [moduleNames.ADMIN_BIDS]: {
    browserTabTitle: 'MonadPlug - Admin | Bids',
    createLabel: 'Add bid',
    editLabel: 'Edit',
    deleteLabel: 'Delete',
    editBulkLabel: 'Edit',
    deleteBulkLabel: 'Delete',
    createModalTitle: 'Create bid',
    editModalTitle: 'Edit bid',
    deleteModalTitle: 'Delete bid',
    deleteModalBulkTitle: 'Delete bids',
    editModalBulkTitle: 'Edit bids',
  },
  [moduleNames.ADMIN_CAMPAIGNS]: {
    browserTabTitle: 'MonadPlug - Admin | Campaigns',
    createLabel: 'Add campaign',
    editLabel: 'Edit',
    archiveLabel: 'Archive',
    archiveBulkLabel: 'Archive',
    archiveModalTitle: 'Archive campaign',
    archiveModalBulkTitle: 'Archive campaigns',
    editBulkLabel: 'Edit',
    deleteBulkLabel: 'Delete',
    createModalTitle: 'Create campaign',
    editModalTitle: 'Edit campaign',
    deleteModalTitle: 'Delete campaign',
    deleteModalBulkTitle: 'Delete campaigns',
    editModalBulkTitle: 'Edit campaigns',
    budgetLabel: 'Increase budget',
    bidLabel: 'Bids',
    bidModalTitle: 'Edit bid for',
    budgetModalTitle: 'Edit budget for',
    pauseCampaignLabel: 'Pause campaign',
    activateCampaignLabel: 'Activate campaign',
    activateBulkLabel: 'Activate',
    copyModalTitle: 'Duplicate campaign',
    activateModalBulkTitle: 'Activate campaigns',
    duplicateLabel: 'Duplicate campaign',
    pauseBulkLabel: 'Pause',
    pauseModalBulkTitle: 'Pause campaigns'
  },
  [moduleNames.ADMIN_UNAPPROVED_USERS]: {
    browserTabTitle: 'MonadPlug - Admin | Unapproved users',
    approveLabel: 'Approve',
    setManagerLabel: 'Set manager',
    resetManagerLabel: 'Reset manager',
    rejectLabel: 'Reject',
    rejectBulkLabel: 'Reject',
    rejectModalTitle: 'Reject user',
    rejectModalBulkTitle: 'Reject users',
    appproveModalTitle: 'Approve user',
    appproveModalBody: 'Are you sure you want to approve this user?',
    setManagerModalTitle: 'Set manager',
    setManagerModalBody: 'Are you sure you want to set manager for this user?',
    resetManagerModalTitle: 'Reset manager',
    resetManagerModalBody: 'Are you sure you want to reset manager for user?',
  },
  [moduleNames.ADMIN_PROFILE]: {
    browserTabTitle: 'MonadLead - Profile',
  },
  [moduleNames.ADVERTISER_CAMPAIGNS]: {
    browserTabTitle: 'MonadPlug - Advertiser | Campaigns',
    createLabel: 'Add campaign',
    editLabel: 'Edit',
    deleteLabel: 'Delete',
    editBulkLabel: 'Edit',
    deleteBulkLabel: 'Delete',
    createModalTitle: 'Create campaign',
    editModalTitle: 'Edit campaign',
    deleteModalTitle: 'Delete campaign',
    deleteModalBulkTitle: 'Delete campaigns',
    editModalBulkTitle: 'Edit campaigns',
    budgetLabel: 'Increase budget',
    bidLabel: 'Bids',
    bidModalTitle: 'Edit bid for',
    budgetModalTitle: 'Edit budget for',
    pauseCampaignLabel: 'Pause campaign',
    activateCampaignLabel: 'Activate campaign',
    activateBulkLabel: 'Activate',
    activateModalBulkTitle: 'Activate campaigns',
    pauseBulkLabel: 'Pause',
    pauseModalBulkTitle: 'Pause campaigns',
    copyModalTitle: 'Duplicate campaign',
    duplicateLabel: 'Duplicate',
  },
  [moduleNames.ADVERTISER_CREATIVES]: {
    browserTabTitle: 'MonadPlug - Advertiser | Creatives',
    createLabel: 'Add creative',
    editLabel: 'Edit',
    deleteLabel: 'Delete',
    editBulkLabel: 'Edit',
    deleteBulkLabel: 'Delete',
    createModalTitle: 'Create creative',
    editModalTitle: 'Edit creative',
    deleteModalTitle: 'Delete creative',
    deleteModalBulkTitle: 'Delete creatives',
    editModalBulkTitle: 'Edit creatives',
  },
  [moduleNames.ADVERTISER_DASHBOARD]: {
    browserTabTitle: 'MonadPlug - Advertiser | Dashboard'
  },
  [moduleNames.ADVERTISER_LOGIN_HISTORY]: {
    browserTabTitle: 'MonadPlug - Advertiser | Login history',
  },

  [moduleNames.ADVERTISER_TOPUPS]: {
    browserTabTitle: 'MonadPlug - Advertiser | Topups',
    createRegularLabel: 'Credit card',
    createWithCouponLabel: 'Use a coupon',
    createWithCouponTitle: 'Enter the code below',
  },
  [moduleNames.ADVERTISER_STATS_REPORT]: {
    browserTabTitle: 'MonadPlug - Advertiser | Report',
  },
  [moduleNames.ADVERTISER_LOGIN_HISTORY]: {
    browserTabTitle: 'MonadPlug - Advertiser | Login history',
  },
}

export default en;